import { FC, lazy } from 'react';

const Page = lazy(() => import('./page'));

export const Login: FC = () => {
  return <Page />;
};
